import { FieldPlacement } from 'src/graphql/generated';

export interface ReorderTarget {
  targetFieldId: string;
  placement: FieldPlacement;
}

/**
 * Resolves a drop into the field it should land next to, and which side of it.
 *
 * The table only ever shows a page, filter or search subset, so an index here
 * has no meaning in the organisation's full list — the server resolves the
 * returned id against that list instead.
 *
 * The side comes from the drag direction, which is what keeps a drop on the
 * first visible row at the top of *that view*: without it, "above everything I
 * can see" would be indistinguishable from "top of the whole list", and a drag
 * on page 2 would silently move the field to page 1.
 */
export const getReorderTarget = (
  visibleFieldIds: string[],
  sourceIndex: number,
  destinationIndex: number,
): ReorderTarget => ({
  targetFieldId: visibleFieldIds[destinationIndex],
  placement:
    destinationIndex > sourceIndex
      ? FieldPlacement.After
      : FieldPlacement.Before,
});
